/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BackgroundCheck,
  CustomValidationError,
  DetailedAccountLinking,
  FeatureFlagResponse,
  Market,
  MoveGigToPastResponse,
  PatchedFeatureFlagRequest,
  PatchedMarketRequest,
  SeedFixtureRequest,
  SeedScenarioRequest,
  StageBackgroundCheckRequest,
  TestingAcceptTosCreate200,
  TestingAcceptTosCreateParams,
  TestingAddCertificationRetrieve200,
  TestingAddCertificationRetrieveParams,
  TestingAddGigApplicationsToGigRetrieve200,
  TestingAddGigApplicationsToGigRetrieveParams,
  TestingAddGigsterProfileRetrieve200,
  TestingAddGigsterProfileRetrieve400,
  TestingAddGigsterProfileRetrieve404,
  TestingAddGigsterProfileRetrieveParams,
  TestingAddGigsterProfileW2DetailsRetrieve200,
  TestingAddGigsterProfileW2DetailsRetrieveParams,
  TestingAddLocationW2DetailsRetrieve200,
  TestingAddLocationW2DetailsRetrieveParams,
  TestingAddMatchScoreForGigApplicationRetrieve200,
  TestingAddMatchScoreForGigApplicationRetrieveParams,
  TestingAddUserLicenseUpdate200,
  TestingAddZealBankAccountRetrieve200,
  TestingAddZealBankAccountRetrieveParams,
  TestingAdjustGigStartEndTimeRetrieve200,
  TestingAdjustGigStartEndTimeRetrieveParams,
  TestingAdjustTimesheetClockInOutRetrieve200,
  TestingAdjustTimesheetClockInOutRetrieveParams,
  TestingCleanupGigsDestroy200,
  TestingCleanupSeedDataDestroy200,
  TestingCompleteZealOnboardingRetrieve200,
  TestingCompleteZealOnboardingRetrieveParams,
  TestingCreateAndApproveBackgroundCheckCreateParams,
  TestingCreateBillingPaymentMethodForOrgCreate200,
  TestingCreateBillingPaymentMethodForOrgCreate201,
  TestingCreateBillingPaymentMethodForOrgCreateParams,
  TestingCreateGigsterStripeAccountCreate200,
  TestingCreateGigsterStripeAccountCreateParams,
  TestingCreateMarketRetrieveParams,
  TestingCreateReviewSummaryDataForProCreate200,
  TestingCreateReviewSummaryDataForProCreateParams,
  TestingCreateUserRetrieve200,
  TestingCreateUserRetrieveParams,
  TestingCreateZealContractorAccountCreate201,
  TestingCreateZealContractorAccountCreateParams,
  TestingDeleteAccountDestroy200,
  TestingDeleteAccountDestroyParams,
  TestingDeleteGigsterStripeAccountDestroy200,
  TestingDeleteGigsterStripeAccountDestroyParams,
  TestingFeatureFlagsDestroy200,
  TestingFillGigsterProfileRetrieve200,
  TestingFillGigsterProfileRetrieveParams,
  TestingGenerateTestPhoneRetrieve200,
  TestingGetGigsterStripeAccountRetrieve200,
  TestingGetGigsterStripeAccountRetrieveParams,
  TestingGetLinkableAccountsListParams,
  TestingGetOtpCodeRetrieve200,
  TestingGetOtpCodeRetrieveParams,
  TestingGetTokenForPhoneNumberRetrieve200,
  TestingGetTokenForPhoneNumberRetrieveParams,
  TestingGetTokenForUserIdRetrieve200,
  TestingGetTokenForUserIdRetrieveParams,
  TestingGetTokenForUserUuidRetrieve200,
  TestingGetTokenForUserUuidRetrieveParams,
  TestingGetTokenForUsernameRetrieve200,
  TestingGetTokenForUsernameRetrieveParams,
  TestingInvalidateAllCacheRetrieve200,
  TestingMoveGigToPastCreateParams,
  TestingReleasePhoneNumberDestroy200,
  TestingReleasePhoneNumberDestroyParams,
  TestingRemoveUserLicenseDestroy200,
  TestingRemoveUserLicenseDestroy204,
  TestingRunRippleRulesRetrieve200,
  TestingSeedFixtureCreate201,
  TestingSeedFixtureCreate400,
  TestingSeedFixtureCreate409,
  TestingSeedFixtureCreate422,
  TestingSeedFixtureCreate429,
  TestingSeedGigBreakRetrieve200,
  TestingSeedRosterProRetrieve200,
  TestingSeedRosterProRetrieve404,
  TestingSeedScenarioCreate201,
  TestingSetProCoordinatesRetrieve200,
  TestingSetProCoordinatesRetrieveParams,
  TestingStageBackgroundCheckCreateParams,
  TestingUpdateZealPiiRetrieve200,
  TestingUpdateZealPiiRetrieveParams,
  TestingValidateTokenRetrieve200,
  TestingValidateTokenRetrieveParams,
  UserLicensePerLocationRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTestingAcceptTosCreateUrl = (params: TestingAcceptTosCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/accept_tos/?${stringifiedParams}` : `/api/testing/accept_tos/`
}

/**
 * Record (or refresh) a TOS acceptance for an existing user, e.g. a manager QA created through signup.
 */
export const testingAcceptTosCreate = async (params: TestingAcceptTosCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAcceptTosCreate200> => {

  return customFetch<TestingAcceptTosCreate200>(getTestingAcceptTosCreateUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestingAcceptTosCreateMutationKey = () => ['testingAcceptTosCreate'] as const;

export const getTestingAcceptTosCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingAcceptTosCreate>>, TError,TestingAcceptTosCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingAcceptTosCreate>>, TError,TestingAcceptTosCreateMutationVariables, TContext> => {

const mutationKey = getTestingAcceptTosCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingAcceptTosCreate>>, TestingAcceptTosCreateMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingAcceptTosCreate(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingAcceptTosCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingAcceptTosCreate>>>

    export type TestingAcceptTosCreateMutationError = void
    export type TestingAcceptTosCreateMutationVariables = {params: TestingAcceptTosCreateParams}

    export const useTestingAcceptTosCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingAcceptTosCreate>>, TError,TestingAcceptTosCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingAcceptTosCreate>>,
        TError,
        TestingAcceptTosCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingAcceptTosCreateMutationOptions(options), queryClient);
    }
    export const getTestingAddCertificationRetrieveUrl = (params: TestingAddCertificationRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/add_certification/?${stringifiedParams}` : `/api/testing/add_certification/`
}

/**
 * Add active certification to gigster profile (supply user_id as input). This endpoint is idempotent.
 */
export const testingAddCertificationRetrieve = async (params: TestingAddCertificationRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddCertificationRetrieve200> => {

  return customFetch<TestingAddCertificationRetrieve200>(getTestingAddCertificationRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAddCertificationRetrieveQueryKey = (params?: TestingAddCertificationRetrieveParams,) => {
    return [
    `/api/testing/add_certification/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAddCertificationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError = void>(params: TestingAddCertificationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAddCertificationRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>> = ({ signal }) => testingAddCertificationRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAddCertificationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>>
export type TestingAddCertificationRetrieveQueryError = void


export function useTestingAddCertificationRetrieve<TData = Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError = void>(
 params: TestingAddCertificationRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddCertificationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddCertificationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddCertificationRetrieve<TData = Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError = void>(
 params: TestingAddCertificationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddCertificationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddCertificationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddCertificationRetrieve<TData = Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError = void>(
 params: TestingAddCertificationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAddCertificationRetrieve<TData = Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError = void>(
 params: TestingAddCertificationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddCertificationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAddCertificationRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAddGigApplicationsToGigRetrieveUrl = (gigId: number,
    params: TestingAddGigApplicationsToGigRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/add_gig_applications_to_gig/${gigId}/?${stringifiedParams}` : `/api/testing/add_gig_applications_to_gig/${gigId}/`
}

/**
 * Add requested number of pro gig applications to a gig (new pros and new gigster profiles will be created)
 */
export const testingAddGigApplicationsToGigRetrieve = async (gigId: number,
    params: TestingAddGigApplicationsToGigRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddGigApplicationsToGigRetrieve200> => {

  return customFetch<TestingAddGigApplicationsToGigRetrieve200>(getTestingAddGigApplicationsToGigRetrieveUrl(gigId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAddGigApplicationsToGigRetrieveQueryKey = (gigId: number,
    params?: TestingAddGigApplicationsToGigRetrieveParams,) => {
    return [
    `/api/testing/add_gig_applications_to_gig/${gigId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAddGigApplicationsToGigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError = void>(gigId: number,
    params: TestingAddGigApplicationsToGigRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAddGigApplicationsToGigRetrieveQueryKey(gigId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>> = ({ signal }) => testingAddGigApplicationsToGigRetrieve(gigId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: gigId !== null && gigId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAddGigApplicationsToGigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>>
export type TestingAddGigApplicationsToGigRetrieveQueryError = void


export function useTestingAddGigApplicationsToGigRetrieve<TData = Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError = void>(
 gigId: number,
    params: TestingAddGigApplicationsToGigRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddGigApplicationsToGigRetrieve<TData = Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError = void>(
 gigId: number,
    params: TestingAddGigApplicationsToGigRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddGigApplicationsToGigRetrieve<TData = Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError = void>(
 gigId: number,
    params: TestingAddGigApplicationsToGigRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAddGigApplicationsToGigRetrieve<TData = Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError = void>(
 gigId: number,
    params: TestingAddGigApplicationsToGigRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigApplicationsToGigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAddGigApplicationsToGigRetrieveQueryOptions(gigId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAddGigsterProfileRetrieveUrl = (params: TestingAddGigsterProfileRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/add_gigster_profile/?${stringifiedParams}` : `/api/testing/add_gigster_profile/`
}

/**
 * Get or create the gigster profile of a user with GIGSTER app_mode, attach a Stripe account and accept
 * pending network organization invitations.
 *
 * Idempotent (CORE-7851): the E2E retry wrapper re-drives this request after a transient 5xx whose write
 * already landed, so an existing profile is the retry's normal case, not a 409. A repeat call applies only
 * the caller-controlled params present in the request (``add_stripe`` included), so an identical retry is
 * a no-op and a bare re-call does not reset a customized profile to the defaults. Both paths answer with
 * the create shape.
 */
export const testingAddGigsterProfileRetrieve = async (params: TestingAddGigsterProfileRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddGigsterProfileRetrieve200> => {

  return customFetch<TestingAddGigsterProfileRetrieve200>(getTestingAddGigsterProfileRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAddGigsterProfileRetrieveQueryKey = (params?: TestingAddGigsterProfileRetrieveParams,) => {
    return [
    `/api/testing/add_gigster_profile/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAddGigsterProfileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError = TestingAddGigsterProfileRetrieve400 | void | TestingAddGigsterProfileRetrieve404>(params: TestingAddGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAddGigsterProfileRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>> = ({ signal }) => testingAddGigsterProfileRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAddGigsterProfileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>>
export type TestingAddGigsterProfileRetrieveQueryError = TestingAddGigsterProfileRetrieve400 | void | TestingAddGigsterProfileRetrieve404


export function useTestingAddGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError = TestingAddGigsterProfileRetrieve400 | void | TestingAddGigsterProfileRetrieve404>(
 params: TestingAddGigsterProfileRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError = TestingAddGigsterProfileRetrieve400 | void | TestingAddGigsterProfileRetrieve404>(
 params: TestingAddGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError = TestingAddGigsterProfileRetrieve400 | void | TestingAddGigsterProfileRetrieve404>(
 params: TestingAddGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAddGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError = TestingAddGigsterProfileRetrieve400 | void | TestingAddGigsterProfileRetrieve404>(
 params: TestingAddGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAddGigsterProfileRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAddGigsterProfileW2DetailsRetrieveUrl = (params: TestingAddGigsterProfileW2DetailsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/add_gigster_profile_w2_details/?${stringifiedParams}` : `/api/testing/add_gigster_profile_w2_details/`
}

/**
 * Set up a gigster profile for W2 and register them with Zeal.
 *
 * Step 1 of the W2 onboarding test flow. Call this before complete_zeal_onboarding.
 */
export const testingAddGigsterProfileW2DetailsRetrieve = async (params: TestingAddGigsterProfileW2DetailsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddGigsterProfileW2DetailsRetrieve200> => {

  return customFetch<TestingAddGigsterProfileW2DetailsRetrieve200>(getTestingAddGigsterProfileW2DetailsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAddGigsterProfileW2DetailsRetrieveQueryKey = (params?: TestingAddGigsterProfileW2DetailsRetrieveParams,) => {
    return [
    `/api/testing/add_gigster_profile_w2_details/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAddGigsterProfileW2DetailsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError = void>(params: TestingAddGigsterProfileW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAddGigsterProfileW2DetailsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>> = ({ signal }) => testingAddGigsterProfileW2DetailsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAddGigsterProfileW2DetailsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>>
export type TestingAddGigsterProfileW2DetailsRetrieveQueryError = void


export function useTestingAddGigsterProfileW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError = void>(
 params: TestingAddGigsterProfileW2DetailsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddGigsterProfileW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError = void>(
 params: TestingAddGigsterProfileW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddGigsterProfileW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError = void>(
 params: TestingAddGigsterProfileW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAddGigsterProfileW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError = void>(
 params: TestingAddGigsterProfileW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddGigsterProfileW2DetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAddGigsterProfileW2DetailsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAddLocationW2DetailsRetrieveUrl = (params: TestingAddLocationW2DetailsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/add_location_w2_details/?${stringifiedParams}` : `/api/testing/add_location_w2_details/`
}

/**
 * Add W2 details to location
 */
export const testingAddLocationW2DetailsRetrieve = async (params: TestingAddLocationW2DetailsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddLocationW2DetailsRetrieve200> => {

  return customFetch<TestingAddLocationW2DetailsRetrieve200>(getTestingAddLocationW2DetailsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAddLocationW2DetailsRetrieveQueryKey = (params?: TestingAddLocationW2DetailsRetrieveParams,) => {
    return [
    `/api/testing/add_location_w2_details/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAddLocationW2DetailsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError = void>(params: TestingAddLocationW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAddLocationW2DetailsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>> = ({ signal }) => testingAddLocationW2DetailsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAddLocationW2DetailsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>>
export type TestingAddLocationW2DetailsRetrieveQueryError = void


export function useTestingAddLocationW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError = void>(
 params: TestingAddLocationW2DetailsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddLocationW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError = void>(
 params: TestingAddLocationW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddLocationW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError = void>(
 params: TestingAddLocationW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAddLocationW2DetailsRetrieve<TData = Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError = void>(
 params: TestingAddLocationW2DetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddLocationW2DetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAddLocationW2DetailsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAddMatchScoreForGigApplicationRetrieveUrl = (params?: TestingAddMatchScoreForGigApplicationRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/add_match_score_for_gig_application/?${stringifiedParams}` : `/api/testing/add_match_score_for_gig_application/`
}

/**
 * Creates or updates MatchScore record with specified value for gig_application
 */
export const testingAddMatchScoreForGigApplicationRetrieve = async (params?: TestingAddMatchScoreForGigApplicationRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddMatchScoreForGigApplicationRetrieve200> => {

  return customFetch<TestingAddMatchScoreForGigApplicationRetrieve200>(getTestingAddMatchScoreForGigApplicationRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAddMatchScoreForGigApplicationRetrieveQueryKey = (params?: TestingAddMatchScoreForGigApplicationRetrieveParams,) => {
    return [
    `/api/testing/add_match_score_for_gig_application/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAddMatchScoreForGigApplicationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError = void>(params?: TestingAddMatchScoreForGigApplicationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAddMatchScoreForGigApplicationRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>> = ({ signal }) => testingAddMatchScoreForGigApplicationRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAddMatchScoreForGigApplicationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>>
export type TestingAddMatchScoreForGigApplicationRetrieveQueryError = void


export function useTestingAddMatchScoreForGigApplicationRetrieve<TData = Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError = void>(
 params: undefined |  TestingAddMatchScoreForGigApplicationRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddMatchScoreForGigApplicationRetrieve<TData = Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError = void>(
 params?: TestingAddMatchScoreForGigApplicationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddMatchScoreForGigApplicationRetrieve<TData = Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError = void>(
 params?: TestingAddMatchScoreForGigApplicationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAddMatchScoreForGigApplicationRetrieve<TData = Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError = void>(
 params?: TestingAddMatchScoreForGigApplicationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddMatchScoreForGigApplicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAddMatchScoreForGigApplicationRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAddUserLicenseUpdateUrl = () => {




  return `/api/testing/add_user_license/`
}

/**
 * Add a license to a user on a location. This endpoint is idempotent
 */
export const testingAddUserLicenseUpdate = async (userLicensePerLocationRequest: UserLicensePerLocationRequest, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddUserLicenseUpdate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TestingAddUserLicenseUpdate200>(getTestingAddUserLicenseUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userLicensePerLocationRequest)
  }
);}





export const getTestingAddUserLicenseUpdateMutationKey = () => ['testingAddUserLicenseUpdate'] as const;

export const getTestingAddUserLicenseUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingAddUserLicenseUpdate>>, TError,TestingAddUserLicenseUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingAddUserLicenseUpdate>>, TError,TestingAddUserLicenseUpdateMutationVariables, TContext> => {

const mutationKey = getTestingAddUserLicenseUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingAddUserLicenseUpdate>>, TestingAddUserLicenseUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testingAddUserLicenseUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingAddUserLicenseUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof testingAddUserLicenseUpdate>>>
    export type TestingAddUserLicenseUpdateMutationBody = UserLicensePerLocationRequest
    export type TestingAddUserLicenseUpdateMutationError = void
    export type TestingAddUserLicenseUpdateMutationVariables = {data: UserLicensePerLocationRequest}

    export const useTestingAddUserLicenseUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingAddUserLicenseUpdate>>, TError,TestingAddUserLicenseUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingAddUserLicenseUpdate>>,
        TError,
        TestingAddUserLicenseUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingAddUserLicenseUpdateMutationOptions(options), queryClient);
    }
    export const getTestingAddZealBankAccountRetrieveUrl = (params: TestingAddZealBankAccountRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/add_zeal_bank_account/?${stringifiedParams}` : `/api/testing/add_zeal_bank_account/`
}

/**
 * Add a test bank account to a Zeal employee and mark the employee as onboarded.
 *
 * Use after update_zeal_pii to complete W2 onboarding. Records an E-Verify event first (see everify_status).
 */
export const testingAddZealBankAccountRetrieve = async (params: TestingAddZealBankAccountRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAddZealBankAccountRetrieve200> => {

  return customFetch<TestingAddZealBankAccountRetrieve200>(getTestingAddZealBankAccountRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAddZealBankAccountRetrieveQueryKey = (params?: TestingAddZealBankAccountRetrieveParams,) => {
    return [
    `/api/testing/add_zeal_bank_account/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAddZealBankAccountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError = void>(params: TestingAddZealBankAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAddZealBankAccountRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>> = ({ signal }) => testingAddZealBankAccountRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAddZealBankAccountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>>
export type TestingAddZealBankAccountRetrieveQueryError = void


export function useTestingAddZealBankAccountRetrieve<TData = Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError = void>(
 params: TestingAddZealBankAccountRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddZealBankAccountRetrieve<TData = Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError = void>(
 params: TestingAddZealBankAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAddZealBankAccountRetrieve<TData = Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError = void>(
 params: TestingAddZealBankAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAddZealBankAccountRetrieve<TData = Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError = void>(
 params: TestingAddZealBankAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAddZealBankAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAddZealBankAccountRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAdjustGigStartEndTimeRetrieveUrl = (gigId: number,
    params?: TestingAdjustGigStartEndTimeRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/adjust_gig_start_end_time/${gigId}/?${stringifiedParams}` : `/api/testing/adjust_gig_start_end_time/${gigId}/`
}

/**
 * Modify gig start and end times.
 */
export const testingAdjustGigStartEndTimeRetrieve = async (gigId: number,
    params?: TestingAdjustGigStartEndTimeRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAdjustGigStartEndTimeRetrieve200> => {

  return customFetch<TestingAdjustGigStartEndTimeRetrieve200>(getTestingAdjustGigStartEndTimeRetrieveUrl(gigId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAdjustGigStartEndTimeRetrieveQueryKey = (gigId: number,
    params?: TestingAdjustGigStartEndTimeRetrieveParams,) => {
    return [
    `/api/testing/adjust_gig_start_end_time/${gigId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAdjustGigStartEndTimeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError = void>(gigId: number,
    params?: TestingAdjustGigStartEndTimeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAdjustGigStartEndTimeRetrieveQueryKey(gigId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>> = ({ signal }) => testingAdjustGigStartEndTimeRetrieve(gigId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: gigId !== null && gigId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAdjustGigStartEndTimeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>>
export type TestingAdjustGigStartEndTimeRetrieveQueryError = void


export function useTestingAdjustGigStartEndTimeRetrieve<TData = Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError = void>(
 gigId: number,
    params: undefined |  TestingAdjustGigStartEndTimeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAdjustGigStartEndTimeRetrieve<TData = Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError = void>(
 gigId: number,
    params?: TestingAdjustGigStartEndTimeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAdjustGigStartEndTimeRetrieve<TData = Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError = void>(
 gigId: number,
    params?: TestingAdjustGigStartEndTimeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAdjustGigStartEndTimeRetrieve<TData = Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError = void>(
 gigId: number,
    params?: TestingAdjustGigStartEndTimeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustGigStartEndTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAdjustGigStartEndTimeRetrieveQueryOptions(gigId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingAdjustTimesheetClockInOutRetrieveUrl = (timesheetUuidOrGigId: string | number,
    params?: TestingAdjustTimesheetClockInOutRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/adjust_timesheet_clock_in_out/${timesheetUuidOrGigId}/?${stringifiedParams}` : `/api/testing/adjust_timesheet_clock_in_out/${timesheetUuidOrGigId}/`
}

/**
 * Modify timesheet clock in and clock out times.
 */
export const testingAdjustTimesheetClockInOutRetrieve = async (timesheetUuidOrGigId: string | number,
    params?: TestingAdjustTimesheetClockInOutRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingAdjustTimesheetClockInOutRetrieve200> => {

  return customFetch<TestingAdjustTimesheetClockInOutRetrieve200>(getTestingAdjustTimesheetClockInOutRetrieveUrl(timesheetUuidOrGigId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingAdjustTimesheetClockInOutRetrieveQueryKey = (timesheetUuidOrGigId: string | number,
    params?: TestingAdjustTimesheetClockInOutRetrieveParams,) => {
    return [
    `/api/testing/adjust_timesheet_clock_in_out/${timesheetUuidOrGigId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingAdjustTimesheetClockInOutRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError = void>(timesheetUuidOrGigId: string | number,
    params?: TestingAdjustTimesheetClockInOutRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingAdjustTimesheetClockInOutRetrieveQueryKey(timesheetUuidOrGigId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>> = ({ signal }) => testingAdjustTimesheetClockInOutRetrieve(timesheetUuidOrGigId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: timesheetUuidOrGigId !== null && timesheetUuidOrGigId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingAdjustTimesheetClockInOutRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>>
export type TestingAdjustTimesheetClockInOutRetrieveQueryError = void


export function useTestingAdjustTimesheetClockInOutRetrieve<TData = Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError = void>(
 timesheetUuidOrGigId: string | number,
    params: undefined |  TestingAdjustTimesheetClockInOutRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAdjustTimesheetClockInOutRetrieve<TData = Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError = void>(
 timesheetUuidOrGigId: string | number,
    params?: TestingAdjustTimesheetClockInOutRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingAdjustTimesheetClockInOutRetrieve<TData = Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError = void>(
 timesheetUuidOrGigId: string | number,
    params?: TestingAdjustTimesheetClockInOutRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingAdjustTimesheetClockInOutRetrieve<TData = Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError = void>(
 timesheetUuidOrGigId: string | number,
    params?: TestingAdjustTimesheetClockInOutRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingAdjustTimesheetClockInOutRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingAdjustTimesheetClockInOutRetrieveQueryOptions(timesheetUuidOrGigId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingCleanupGigsDestroyUrl = () => {




  return `/api/testing/cleanup_gigs/`
}

/**
 * Wipe every Gig row + FK dependents.
 *
 * Unlike ``cleanup_seed_data`` (scoped to seed-pattern users), this
 * nukes ALL Gigs in the database — useful for resetting local dev
 * state when you want to re-seed gigs against an existing
 * business/location without wiping the user graph.
 *
 * Dependents (GigApplication, GigShift, timesheets, payments, etc.)
 * are walked via the same FK-graph traversal.
 */
export const testingCleanupGigsDestroy = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestingCleanupGigsDestroy200> => {

  return customFetch<TestingCleanupGigsDestroy200>(getTestingCleanupGigsDestroyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTestingCleanupGigsDestroyMutationKey = () => ['testingCleanupGigsDestroy'] as const;

export const getTestingCleanupGigsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCleanupGigsDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingCleanupGigsDestroy>>, TError,void, TContext> => {

const mutationKey = getTestingCleanupGigsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingCleanupGigsDestroy>>, void> = () => {


          return  testingCleanupGigsDestroy(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingCleanupGigsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof testingCleanupGigsDestroy>>>

    export type TestingCleanupGigsDestroyMutationError = void


    export const useTestingCleanupGigsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCleanupGigsDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingCleanupGigsDestroy>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestingCleanupGigsDestroyMutationOptions(options), queryClient);
    }
    export const getTestingCleanupSeedDataDestroyUrl = () => {




  return `/api/testing/cleanup_seed_data/`
}

/**
 * Wipe DB rows belonging to seed-pattern users.
 *
 * Identifies test users by email regex (``*+seed*@qwick.test``,
 * ``*@example.com``, ``*@example.net``) and walks the FK graph
 * backwards from each, deleting every dependent row before deleting
 * the users themselves.
 *
 * **Caveat:** the FK walk follows every reverse relation pointing at
 * the User table, including ``created_by`` / ``last_updated_by`` /
 * ``approved_by`` chains. Reference rows (``Market`` / ``Skill`` /
 * ``Certification`` / ``Organization`` …) are normally untouched, but
 * any reference row whose ``created_by`` is itself a seed user WILL
 * be deleted and cascade onward. This is acceptable for dev/local
 * environments where the same fixtures repopulate reference data on
 * the next seed; do NOT point this endpoint at any database whose
 * reference rows might be authored by a real user.
 *
 * Returns ``{deleted: {users: N, '<app>.<Model>': N, ...}}`` —
 * callers can sum ``deleted.values()`` for a total row count.
 */
export const testingCleanupSeedDataDestroy = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestingCleanupSeedDataDestroy200> => {

  return customFetch<TestingCleanupSeedDataDestroy200>(getTestingCleanupSeedDataDestroyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTestingCleanupSeedDataDestroyMutationKey = () => ['testingCleanupSeedDataDestroy'] as const;

export const getTestingCleanupSeedDataDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCleanupSeedDataDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingCleanupSeedDataDestroy>>, TError,void, TContext> => {

const mutationKey = getTestingCleanupSeedDataDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingCleanupSeedDataDestroy>>, void> = () => {


          return  testingCleanupSeedDataDestroy(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingCleanupSeedDataDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof testingCleanupSeedDataDestroy>>>

    export type TestingCleanupSeedDataDestroyMutationError = void


    export const useTestingCleanupSeedDataDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCleanupSeedDataDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingCleanupSeedDataDestroy>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestingCleanupSeedDataDestroyMutationOptions(options), queryClient);
    }
    export const getTestingCompleteZealOnboardingRetrieveUrl = (params: TestingCompleteZealOnboardingRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/complete_zeal_onboarding/?${stringifiedParams}` : `/api/testing/complete_zeal_onboarding/`
}

/**
 * Complete Zeal onboarding for a W2 pro: update PII and add a test bank account.
 *
 * Convenience endpoint that runs update_zeal_pii and add_zeal_bank_account sequentially.
 * Use after add_gigster_profile_w2_details. Records an E-Verify event first (see everify_status).
 */
export const testingCompleteZealOnboardingRetrieve = async (params: TestingCompleteZealOnboardingRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingCompleteZealOnboardingRetrieve200> => {

  return customFetch<TestingCompleteZealOnboardingRetrieve200>(getTestingCompleteZealOnboardingRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingCompleteZealOnboardingRetrieveQueryKey = (params?: TestingCompleteZealOnboardingRetrieveParams,) => {
    return [
    `/api/testing/complete_zeal_onboarding/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingCompleteZealOnboardingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError = void>(params: TestingCompleteZealOnboardingRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingCompleteZealOnboardingRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>> = ({ signal }) => testingCompleteZealOnboardingRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingCompleteZealOnboardingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>>
export type TestingCompleteZealOnboardingRetrieveQueryError = void


export function useTestingCompleteZealOnboardingRetrieve<TData = Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError = void>(
 params: TestingCompleteZealOnboardingRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingCompleteZealOnboardingRetrieve<TData = Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError = void>(
 params: TestingCompleteZealOnboardingRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingCompleteZealOnboardingRetrieve<TData = Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError = void>(
 params: TestingCompleteZealOnboardingRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingCompleteZealOnboardingRetrieve<TData = Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError = void>(
 params: TestingCompleteZealOnboardingRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCompleteZealOnboardingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingCompleteZealOnboardingRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingCreateAndApproveBackgroundCheckCreateUrl = (params: TestingCreateAndApproveBackgroundCheckCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/create_and_approve_background_check/?${stringifiedParams}` : `/api/testing/create_and_approve_background_check/`
}

/**
 * Create and approve a background check for a gigster: ``stage_background_check`` with its defaults
 * (COMPLETED invitation, CLEAR report, expiring a year from now).
 */
export const testingCreateAndApproveBackgroundCheckCreate = async (params: TestingCreateAndApproveBackgroundCheckCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<BackgroundCheck> => {

  return customFetch<BackgroundCheck>(getTestingCreateAndApproveBackgroundCheckCreateUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestingCreateAndApproveBackgroundCheckCreateMutationKey = () => ['testingCreateAndApproveBackgroundCheckCreate'] as const;

export const getTestingCreateAndApproveBackgroundCheckCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateAndApproveBackgroundCheckCreate>>, TError,TestingCreateAndApproveBackgroundCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingCreateAndApproveBackgroundCheckCreate>>, TError,TestingCreateAndApproveBackgroundCheckCreateMutationVariables, TContext> => {

const mutationKey = getTestingCreateAndApproveBackgroundCheckCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingCreateAndApproveBackgroundCheckCreate>>, TestingCreateAndApproveBackgroundCheckCreateMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingCreateAndApproveBackgroundCheckCreate(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingCreateAndApproveBackgroundCheckCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingCreateAndApproveBackgroundCheckCreate>>>

    export type TestingCreateAndApproveBackgroundCheckCreateMutationError = void
    export type TestingCreateAndApproveBackgroundCheckCreateMutationVariables = {params: TestingCreateAndApproveBackgroundCheckCreateParams}

    export const useTestingCreateAndApproveBackgroundCheckCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateAndApproveBackgroundCheckCreate>>, TError,TestingCreateAndApproveBackgroundCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingCreateAndApproveBackgroundCheckCreate>>,
        TError,
        TestingCreateAndApproveBackgroundCheckCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingCreateAndApproveBackgroundCheckCreateMutationOptions(options), queryClient);
    }
    export const getTestingCreateBillingPaymentMethodForOrgCreateUrl = (params?: TestingCreateBillingPaymentMethodForOrgCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/create_billing_payment_method_for_org/?${stringifiedParams}` : `/api/testing/create_billing_payment_method_for_org/`
}

export const testingCreateBillingPaymentMethodForOrgCreate = async (params?: TestingCreateBillingPaymentMethodForOrgCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingCreateBillingPaymentMethodForOrgCreate200 | TestingCreateBillingPaymentMethodForOrgCreate201> => {

  return customFetch<TestingCreateBillingPaymentMethodForOrgCreate200 | TestingCreateBillingPaymentMethodForOrgCreate201>(getTestingCreateBillingPaymentMethodForOrgCreateUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestingCreateBillingPaymentMethodForOrgCreateMutationKey = () => ['testingCreateBillingPaymentMethodForOrgCreate'] as const;

export const getTestingCreateBillingPaymentMethodForOrgCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateBillingPaymentMethodForOrgCreate>>, TError,TestingCreateBillingPaymentMethodForOrgCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingCreateBillingPaymentMethodForOrgCreate>>, TError,TestingCreateBillingPaymentMethodForOrgCreateMutationVariables, TContext> => {

const mutationKey = getTestingCreateBillingPaymentMethodForOrgCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingCreateBillingPaymentMethodForOrgCreate>>, TestingCreateBillingPaymentMethodForOrgCreateMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingCreateBillingPaymentMethodForOrgCreate(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingCreateBillingPaymentMethodForOrgCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingCreateBillingPaymentMethodForOrgCreate>>>

    export type TestingCreateBillingPaymentMethodForOrgCreateMutationError = void
    export type TestingCreateBillingPaymentMethodForOrgCreateMutationVariables = {params?: TestingCreateBillingPaymentMethodForOrgCreateParams}

    export const useTestingCreateBillingPaymentMethodForOrgCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateBillingPaymentMethodForOrgCreate>>, TError,TestingCreateBillingPaymentMethodForOrgCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingCreateBillingPaymentMethodForOrgCreate>>,
        TError,
        TestingCreateBillingPaymentMethodForOrgCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingCreateBillingPaymentMethodForOrgCreateMutationOptions(options), queryClient);
    }
    export const getTestingCreateGigsterStripeAccountCreateUrl = (params: TestingCreateGigsterStripeAccountCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/create_gigster_stripe_account/?${stringifiedParams}` : `/api/testing/create_gigster_stripe_account/`
}

/**
 * Add Stripe account to a gigster profile
 */
export const testingCreateGigsterStripeAccountCreate = async (params: TestingCreateGigsterStripeAccountCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingCreateGigsterStripeAccountCreate200> => {

  return customFetch<TestingCreateGigsterStripeAccountCreate200>(getTestingCreateGigsterStripeAccountCreateUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestingCreateGigsterStripeAccountCreateMutationKey = () => ['testingCreateGigsterStripeAccountCreate'] as const;

export const getTestingCreateGigsterStripeAccountCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateGigsterStripeAccountCreate>>, TError,TestingCreateGigsterStripeAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingCreateGigsterStripeAccountCreate>>, TError,TestingCreateGigsterStripeAccountCreateMutationVariables, TContext> => {

const mutationKey = getTestingCreateGigsterStripeAccountCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingCreateGigsterStripeAccountCreate>>, TestingCreateGigsterStripeAccountCreateMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingCreateGigsterStripeAccountCreate(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingCreateGigsterStripeAccountCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingCreateGigsterStripeAccountCreate>>>

    export type TestingCreateGigsterStripeAccountCreateMutationError = void
    export type TestingCreateGigsterStripeAccountCreateMutationVariables = {params: TestingCreateGigsterStripeAccountCreateParams}

    export const useTestingCreateGigsterStripeAccountCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateGigsterStripeAccountCreate>>, TError,TestingCreateGigsterStripeAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingCreateGigsterStripeAccountCreate>>,
        TError,
        TestingCreateGigsterStripeAccountCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingCreateGigsterStripeAccountCreateMutationOptions(options), queryClient);
    }
    export const getTestingCreateMarketRetrieveUrl = (params?: TestingCreateMarketRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/create_market/?${stringifiedParams}` : `/api/testing/create_market/`
}

/**
 * Create a new test market, with a PostalCodeData row per ``postal_codes_list`` ZIP so the market is
 * reachable by ZIP lookup. The query string is validated first (400 with field errors: the ZIP row is
 * stricter than the Market, see CreateMarketSerializer), and the market, its nearby_market_ids and the ZIP
 * rows are written in one transaction so a failure leaves no half-created market behind (CORE-8947).
 */
export const testingCreateMarketRetrieve = async (params?: TestingCreateMarketRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<Market> => {

  return customFetch<Market>(getTestingCreateMarketRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingCreateMarketRetrieveQueryKey = (params?: TestingCreateMarketRetrieveParams,) => {
    return [
    `/api/testing/create_market/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingCreateMarketRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError = void>(params?: TestingCreateMarketRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingCreateMarketRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>> = ({ signal }) => testingCreateMarketRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingCreateMarketRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>>
export type TestingCreateMarketRetrieveQueryError = void


export function useTestingCreateMarketRetrieve<TData = Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError = void>(
 params: undefined |  TestingCreateMarketRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingCreateMarketRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingCreateMarketRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingCreateMarketRetrieve<TData = Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError = void>(
 params?: TestingCreateMarketRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingCreateMarketRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingCreateMarketRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingCreateMarketRetrieve<TData = Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError = void>(
 params?: TestingCreateMarketRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingCreateMarketRetrieve<TData = Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError = void>(
 params?: TestingCreateMarketRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateMarketRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingCreateMarketRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingCreateReviewSummaryDataForProCreateUrl = (params: TestingCreateReviewSummaryDataForProCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/create_review_summary_data_for_pro/?${stringifiedParams}` : `/api/testing/create_review_summary_data_for_pro/`
}

/**
 * Create review summary data for a gigster profile
 */
export const testingCreateReviewSummaryDataForProCreate = async (params: TestingCreateReviewSummaryDataForProCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingCreateReviewSummaryDataForProCreate200> => {

  return customFetch<TestingCreateReviewSummaryDataForProCreate200>(getTestingCreateReviewSummaryDataForProCreateUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestingCreateReviewSummaryDataForProCreateMutationKey = () => ['testingCreateReviewSummaryDataForProCreate'] as const;

export const getTestingCreateReviewSummaryDataForProCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateReviewSummaryDataForProCreate>>, TError,TestingCreateReviewSummaryDataForProCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingCreateReviewSummaryDataForProCreate>>, TError,TestingCreateReviewSummaryDataForProCreateMutationVariables, TContext> => {

const mutationKey = getTestingCreateReviewSummaryDataForProCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingCreateReviewSummaryDataForProCreate>>, TestingCreateReviewSummaryDataForProCreateMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingCreateReviewSummaryDataForProCreate(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingCreateReviewSummaryDataForProCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingCreateReviewSummaryDataForProCreate>>>

    export type TestingCreateReviewSummaryDataForProCreateMutationError = void
    export type TestingCreateReviewSummaryDataForProCreateMutationVariables = {params: TestingCreateReviewSummaryDataForProCreateParams}

    export const useTestingCreateReviewSummaryDataForProCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateReviewSummaryDataForProCreate>>, TError,TestingCreateReviewSummaryDataForProCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingCreateReviewSummaryDataForProCreate>>,
        TError,
        TestingCreateReviewSummaryDataForProCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingCreateReviewSummaryDataForProCreateMutationOptions(options), queryClient);
    }
    export const getTestingCreateUserRetrieveUrl = (params?: TestingCreateUserRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/create_user/?${stringifiedParams}` : `/api/testing/create_user/`
}

/**
 * Create a new test user
 */
export const testingCreateUserRetrieve = async (params?: TestingCreateUserRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingCreateUserRetrieve200> => {

  return customFetch<TestingCreateUserRetrieve200>(getTestingCreateUserRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingCreateUserRetrieveQueryKey = (params?: TestingCreateUserRetrieveParams,) => {
    return [
    `/api/testing/create_user/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingCreateUserRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError = void>(params?: TestingCreateUserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingCreateUserRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingCreateUserRetrieve>>> = ({ signal }) => testingCreateUserRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingCreateUserRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingCreateUserRetrieve>>>
export type TestingCreateUserRetrieveQueryError = void


export function useTestingCreateUserRetrieve<TData = Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError = void>(
 params: undefined |  TestingCreateUserRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingCreateUserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingCreateUserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingCreateUserRetrieve<TData = Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError = void>(
 params?: TestingCreateUserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingCreateUserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingCreateUserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingCreateUserRetrieve<TData = Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError = void>(
 params?: TestingCreateUserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingCreateUserRetrieve<TData = Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError = void>(
 params?: TestingCreateUserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingCreateUserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingCreateUserRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingCreateZealContractorAccountCreateUrl = (params: TestingCreateZealContractorAccountCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/create_zeal_contractor_account/?${stringifiedParams}` : `/api/testing/create_zeal_contractor_account/`
}

/**
 * Add Contractor account to a gigster profile
 */
export const testingCreateZealContractorAccountCreate = async (params: TestingCreateZealContractorAccountCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingCreateZealContractorAccountCreate201> => {

  return customFetch<TestingCreateZealContractorAccountCreate201>(getTestingCreateZealContractorAccountCreateUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestingCreateZealContractorAccountCreateMutationKey = () => ['testingCreateZealContractorAccountCreate'] as const;

export const getTestingCreateZealContractorAccountCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateZealContractorAccountCreate>>, TError,TestingCreateZealContractorAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingCreateZealContractorAccountCreate>>, TError,TestingCreateZealContractorAccountCreateMutationVariables, TContext> => {

const mutationKey = getTestingCreateZealContractorAccountCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingCreateZealContractorAccountCreate>>, TestingCreateZealContractorAccountCreateMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingCreateZealContractorAccountCreate(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingCreateZealContractorAccountCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingCreateZealContractorAccountCreate>>>

    export type TestingCreateZealContractorAccountCreateMutationError = void
    export type TestingCreateZealContractorAccountCreateMutationVariables = {params: TestingCreateZealContractorAccountCreateParams}

    export const useTestingCreateZealContractorAccountCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingCreateZealContractorAccountCreate>>, TError,TestingCreateZealContractorAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingCreateZealContractorAccountCreate>>,
        TError,
        TestingCreateZealContractorAccountCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingCreateZealContractorAccountCreateMutationOptions(options), queryClient);
    }
    export const getTestingDeleteAccountDestroyUrl = (params: TestingDeleteAccountDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/delete_account/?${stringifiedParams}` : `/api/testing/delete_account/`
}

export const testingDeleteAccountDestroy = async (params: TestingDeleteAccountDestroyParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingDeleteAccountDestroy200> => {

  return customFetch<TestingDeleteAccountDestroy200>(getTestingDeleteAccountDestroyUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTestingDeleteAccountDestroyMutationKey = () => ['testingDeleteAccountDestroy'] as const;

export const getTestingDeleteAccountDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingDeleteAccountDestroy>>, TError,TestingDeleteAccountDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingDeleteAccountDestroy>>, TError,TestingDeleteAccountDestroyMutationVariables, TContext> => {

const mutationKey = getTestingDeleteAccountDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingDeleteAccountDestroy>>, TestingDeleteAccountDestroyMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingDeleteAccountDestroy(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingDeleteAccountDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof testingDeleteAccountDestroy>>>

    export type TestingDeleteAccountDestroyMutationError = void
    export type TestingDeleteAccountDestroyMutationVariables = {params: TestingDeleteAccountDestroyParams}

    export const useTestingDeleteAccountDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingDeleteAccountDestroy>>, TError,TestingDeleteAccountDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingDeleteAccountDestroy>>,
        TError,
        TestingDeleteAccountDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getTestingDeleteAccountDestroyMutationOptions(options), queryClient);
    }
    export const getTestingDeleteGigsterStripeAccountDestroyUrl = (params: TestingDeleteGigsterStripeAccountDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/delete_gigster_stripe_account/?${stringifiedParams}` : `/api/testing/delete_gigster_stripe_account/`
}

/**
 * Delete and remove Stripe account from a gigster profile
 */
export const testingDeleteGigsterStripeAccountDestroy = async (params: TestingDeleteGigsterStripeAccountDestroyParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingDeleteGigsterStripeAccountDestroy200> => {

  return customFetch<TestingDeleteGigsterStripeAccountDestroy200>(getTestingDeleteGigsterStripeAccountDestroyUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTestingDeleteGigsterStripeAccountDestroyMutationKey = () => ['testingDeleteGigsterStripeAccountDestroy'] as const;

export const getTestingDeleteGigsterStripeAccountDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingDeleteGigsterStripeAccountDestroy>>, TError,TestingDeleteGigsterStripeAccountDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingDeleteGigsterStripeAccountDestroy>>, TError,TestingDeleteGigsterStripeAccountDestroyMutationVariables, TContext> => {

const mutationKey = getTestingDeleteGigsterStripeAccountDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingDeleteGigsterStripeAccountDestroy>>, TestingDeleteGigsterStripeAccountDestroyMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingDeleteGigsterStripeAccountDestroy(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingDeleteGigsterStripeAccountDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof testingDeleteGigsterStripeAccountDestroy>>>

    export type TestingDeleteGigsterStripeAccountDestroyMutationError = void
    export type TestingDeleteGigsterStripeAccountDestroyMutationVariables = {params: TestingDeleteGigsterStripeAccountDestroyParams}

    export const useTestingDeleteGigsterStripeAccountDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingDeleteGigsterStripeAccountDestroy>>, TError,TestingDeleteGigsterStripeAccountDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingDeleteGigsterStripeAccountDestroy>>,
        TError,
        TestingDeleteGigsterStripeAccountDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getTestingDeleteGigsterStripeAccountDestroyMutationOptions(options), queryClient);
    }
    export const getTestingFeatureFlagsPartialUpdateUrl = () => {




  return `/api/testing/feature_flags/`
}

export const testingFeatureFlagsPartialUpdate = async (patchedFeatureFlagRequest?: PatchedFeatureFlagRequest, options?: Parameters<typeof customFetch>[1]): Promise<FeatureFlagResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<FeatureFlagResponse>(getTestingFeatureFlagsPartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedFeatureFlagRequest)
  }
);}





export const getTestingFeatureFlagsPartialUpdateMutationKey = () => ['testingFeatureFlagsPartialUpdate'] as const;

export const getTestingFeatureFlagsPartialUpdateMutationOptions = <TError = void | CustomValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingFeatureFlagsPartialUpdate>>, TError,TestingFeatureFlagsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingFeatureFlagsPartialUpdate>>, TError,TestingFeatureFlagsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getTestingFeatureFlagsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingFeatureFlagsPartialUpdate>>, TestingFeatureFlagsPartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testingFeatureFlagsPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingFeatureFlagsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof testingFeatureFlagsPartialUpdate>>>
    export type TestingFeatureFlagsPartialUpdateMutationBody = PatchedFeatureFlagRequest | undefined
    export type TestingFeatureFlagsPartialUpdateMutationError = void | CustomValidationError
    export type TestingFeatureFlagsPartialUpdateMutationVariables = {data?: PatchedFeatureFlagRequest}

    export const useTestingFeatureFlagsPartialUpdate = <TError = void | CustomValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingFeatureFlagsPartialUpdate>>, TError,TestingFeatureFlagsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingFeatureFlagsPartialUpdate>>,
        TError,
        TestingFeatureFlagsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingFeatureFlagsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getTestingFeatureFlagsDestroyUrl = () => {




  return `/api/testing/feature_flags/`
}

export const testingFeatureFlagsDestroy = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestingFeatureFlagsDestroy200> => {

  return customFetch<TestingFeatureFlagsDestroy200>(getTestingFeatureFlagsDestroyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTestingFeatureFlagsDestroyMutationKey = () => ['testingFeatureFlagsDestroy'] as const;

export const getTestingFeatureFlagsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingFeatureFlagsDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingFeatureFlagsDestroy>>, TError,void, TContext> => {

const mutationKey = getTestingFeatureFlagsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingFeatureFlagsDestroy>>, void> = () => {


          return  testingFeatureFlagsDestroy(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingFeatureFlagsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof testingFeatureFlagsDestroy>>>

    export type TestingFeatureFlagsDestroyMutationError = void


    export const useTestingFeatureFlagsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingFeatureFlagsDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingFeatureFlagsDestroy>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestingFeatureFlagsDestroyMutationOptions(options), queryClient);
    }
    export const getTestingFillGigsterProfileRetrieveUrl = (params: TestingFillGigsterProfileRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/fill_gigster_profile/?${stringifiedParams}` : `/api/testing/fill_gigster_profile/`
}

/**
 * Add competency, work history, pro preferences and verification to gigster profile.
 *
 * Pass ``verified=false`` to skip the EARNED Verification so the pro's INTERVIEW onboarding
 * step resolves to NOT_STARTED instead of APPROVED.
 */
export const testingFillGigsterProfileRetrieve = async (params: TestingFillGigsterProfileRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingFillGigsterProfileRetrieve200> => {

  return customFetch<TestingFillGigsterProfileRetrieve200>(getTestingFillGigsterProfileRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingFillGigsterProfileRetrieveQueryKey = (params?: TestingFillGigsterProfileRetrieveParams,) => {
    return [
    `/api/testing/fill_gigster_profile/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingFillGigsterProfileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError = void>(params: TestingFillGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingFillGigsterProfileRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>> = ({ signal }) => testingFillGigsterProfileRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingFillGigsterProfileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>>
export type TestingFillGigsterProfileRetrieveQueryError = void


export function useTestingFillGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError = void>(
 params: TestingFillGigsterProfileRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingFillGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError = void>(
 params: TestingFillGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingFillGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError = void>(
 params: TestingFillGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingFillGigsterProfileRetrieve<TData = Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError = void>(
 params: TestingFillGigsterProfileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingFillGigsterProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingFillGigsterProfileRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGenerateTestPhoneRetrieveUrl = () => {




  return `/api/testing/generate_test_phone/`
}

/**
 * Generate a random unused test phone number.
 */
export const testingGenerateTestPhoneRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestingGenerateTestPhoneRetrieve200> => {

  return customFetch<TestingGenerateTestPhoneRetrieve200>(getTestingGenerateTestPhoneRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGenerateTestPhoneRetrieveQueryKey = () => {
    return [
    `/api/testing/generate_test_phone/`
    ] as const;
    }


export const getTestingGenerateTestPhoneRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGenerateTestPhoneRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>> = ({ signal }) => testingGenerateTestPhoneRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGenerateTestPhoneRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>>
export type TestingGenerateTestPhoneRetrieveQueryError = void


export function useTestingGenerateTestPhoneRetrieve<TData = Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGenerateTestPhoneRetrieve<TData = Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGenerateTestPhoneRetrieve<TData = Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGenerateTestPhoneRetrieve<TData = Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGenerateTestPhoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGenerateTestPhoneRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGetGigsterStripeAccountRetrieveUrl = (params: TestingGetGigsterStripeAccountRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/get_gigster_stripe_account/?${stringifiedParams}` : `/api/testing/get_gigster_stripe_account/`
}

/**
 * Get Stripe account details for a gigster profile
 */
export const testingGetGigsterStripeAccountRetrieve = async (params: TestingGetGigsterStripeAccountRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingGetGigsterStripeAccountRetrieve200> => {

  return customFetch<TestingGetGigsterStripeAccountRetrieve200>(getTestingGetGigsterStripeAccountRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGetGigsterStripeAccountRetrieveQueryKey = (params?: TestingGetGigsterStripeAccountRetrieveParams,) => {
    return [
    `/api/testing/get_gigster_stripe_account/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingGetGigsterStripeAccountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError = void>(params: TestingGetGigsterStripeAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGetGigsterStripeAccountRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>> = ({ signal }) => testingGetGigsterStripeAccountRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGetGigsterStripeAccountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>>
export type TestingGetGigsterStripeAccountRetrieveQueryError = void


export function useTestingGetGigsterStripeAccountRetrieve<TData = Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError = void>(
 params: TestingGetGigsterStripeAccountRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetGigsterStripeAccountRetrieve<TData = Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError = void>(
 params: TestingGetGigsterStripeAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetGigsterStripeAccountRetrieve<TData = Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError = void>(
 params: TestingGetGigsterStripeAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGetGigsterStripeAccountRetrieve<TData = Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError = void>(
 params: TestingGetGigsterStripeAccountRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetGigsterStripeAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGetGigsterStripeAccountRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGetLinkableAccountsListUrl = (params?: TestingGetLinkableAccountsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/get_linkable_accounts/?${stringifiedParams}` : `/api/testing/get_linkable_accounts/`
}

/**
 * Get accounts that can be linked to the user with the specified uuid.
 */
export const testingGetLinkableAccountsList = async (params?: TestingGetLinkableAccountsListParams, options?: Parameters<typeof customFetch>[1]): Promise<DetailedAccountLinking[]> => {

  return customFetch<DetailedAccountLinking[]>(getTestingGetLinkableAccountsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGetLinkableAccountsListQueryKey = (params?: TestingGetLinkableAccountsListParams,) => {
    return [
    `/api/testing/get_linkable_accounts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingGetLinkableAccountsListQueryOptions = <TData = Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError = void>(params?: TestingGetLinkableAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGetLinkableAccountsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>> = ({ signal }) => testingGetLinkableAccountsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGetLinkableAccountsListQueryResult = NonNullable<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>>
export type TestingGetLinkableAccountsListQueryError = void


export function useTestingGetLinkableAccountsList<TData = Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError = void>(
 params: undefined |  TestingGetLinkableAccountsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetLinkableAccountsList>>,
          TError,
          Awaited<ReturnType<typeof testingGetLinkableAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetLinkableAccountsList<TData = Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError = void>(
 params?: TestingGetLinkableAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetLinkableAccountsList>>,
          TError,
          Awaited<ReturnType<typeof testingGetLinkableAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetLinkableAccountsList<TData = Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError = void>(
 params?: TestingGetLinkableAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGetLinkableAccountsList<TData = Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError = void>(
 params?: TestingGetLinkableAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetLinkableAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGetLinkableAccountsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGetOtpCodeRetrieveUrl = (params?: TestingGetOtpCodeRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/get_otp_code/?${stringifiedParams}` : `/api/testing/get_otp_code/`
}

/**
 * Retrieve the latest OTP code for a phone number.
 *
 * Reads from the Django cache where the SMS delivery callback stores
 * OTP codes. This returns the exact code tied to the web app's session,
 * enabling browser-based e2e testing.
 */
export const testingGetOtpCodeRetrieve = async (params?: TestingGetOtpCodeRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingGetOtpCodeRetrieve200> => {

  return customFetch<TestingGetOtpCodeRetrieve200>(getTestingGetOtpCodeRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGetOtpCodeRetrieveQueryKey = (params?: TestingGetOtpCodeRetrieveParams,) => {
    return [
    `/api/testing/get_otp_code/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingGetOtpCodeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError = void>(params?: TestingGetOtpCodeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGetOtpCodeRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>> = ({ signal }) => testingGetOtpCodeRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGetOtpCodeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>>
export type TestingGetOtpCodeRetrieveQueryError = void


export function useTestingGetOtpCodeRetrieve<TData = Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError = void>(
 params: undefined |  TestingGetOtpCodeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetOtpCodeRetrieve<TData = Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError = void>(
 params?: TestingGetOtpCodeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetOtpCodeRetrieve<TData = Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError = void>(
 params?: TestingGetOtpCodeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGetOtpCodeRetrieve<TData = Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError = void>(
 params?: TestingGetOtpCodeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetOtpCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGetOtpCodeRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGetTokenForPhoneNumberRetrieveUrl = (params?: TestingGetTokenForPhoneNumberRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/get_token_for_phone_number/?${stringifiedParams}` : `/api/testing/get_token_for_phone_number/`
}

/**
 * Get authentication (Bearer) token for existing user with specified phone number.
 */
export const testingGetTokenForPhoneNumberRetrieve = async (params?: TestingGetTokenForPhoneNumberRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingGetTokenForPhoneNumberRetrieve200> => {

  return customFetch<TestingGetTokenForPhoneNumberRetrieve200>(getTestingGetTokenForPhoneNumberRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGetTokenForPhoneNumberRetrieveQueryKey = (params?: TestingGetTokenForPhoneNumberRetrieveParams,) => {
    return [
    `/api/testing/get_token_for_phone_number/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingGetTokenForPhoneNumberRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError = void>(params?: TestingGetTokenForPhoneNumberRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGetTokenForPhoneNumberRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>> = ({ signal }) => testingGetTokenForPhoneNumberRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGetTokenForPhoneNumberRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>>
export type TestingGetTokenForPhoneNumberRetrieveQueryError = void


export function useTestingGetTokenForPhoneNumberRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError = void>(
 params: undefined |  TestingGetTokenForPhoneNumberRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForPhoneNumberRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError = void>(
 params?: TestingGetTokenForPhoneNumberRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForPhoneNumberRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError = void>(
 params?: TestingGetTokenForPhoneNumberRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGetTokenForPhoneNumberRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError = void>(
 params?: TestingGetTokenForPhoneNumberRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForPhoneNumberRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGetTokenForPhoneNumberRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGetTokenForUserIdRetrieveUrl = (params: TestingGetTokenForUserIdRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/get_token_for_user_id/?${stringifiedParams}` : `/api/testing/get_token_for_user_id/`
}

/**
 * Get authentication (Bearer) token for specified existing user id.
 */
export const testingGetTokenForUserIdRetrieve = async (params: TestingGetTokenForUserIdRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingGetTokenForUserIdRetrieve200> => {

  return customFetch<TestingGetTokenForUserIdRetrieve200>(getTestingGetTokenForUserIdRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGetTokenForUserIdRetrieveQueryKey = (params?: TestingGetTokenForUserIdRetrieveParams,) => {
    return [
    `/api/testing/get_token_for_user_id/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingGetTokenForUserIdRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError = void>(params: TestingGetTokenForUserIdRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGetTokenForUserIdRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>> = ({ signal }) => testingGetTokenForUserIdRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGetTokenForUserIdRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>>
export type TestingGetTokenForUserIdRetrieveQueryError = void


export function useTestingGetTokenForUserIdRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError = void>(
 params: TestingGetTokenForUserIdRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForUserIdRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError = void>(
 params: TestingGetTokenForUserIdRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForUserIdRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError = void>(
 params: TestingGetTokenForUserIdRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGetTokenForUserIdRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError = void>(
 params: TestingGetTokenForUserIdRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserIdRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGetTokenForUserIdRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGetTokenForUserUuidRetrieveUrl = (params?: TestingGetTokenForUserUuidRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/get_token_for_user_uuid/?${stringifiedParams}` : `/api/testing/get_token_for_user_uuid/`
}

/**
 * Get authentication (Bearer) token for specified existing user uuid.
 */
export const testingGetTokenForUserUuidRetrieve = async (params?: TestingGetTokenForUserUuidRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingGetTokenForUserUuidRetrieve200> => {

  return customFetch<TestingGetTokenForUserUuidRetrieve200>(getTestingGetTokenForUserUuidRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGetTokenForUserUuidRetrieveQueryKey = (params?: TestingGetTokenForUserUuidRetrieveParams,) => {
    return [
    `/api/testing/get_token_for_user_uuid/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingGetTokenForUserUuidRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError = void>(params?: TestingGetTokenForUserUuidRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGetTokenForUserUuidRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>> = ({ signal }) => testingGetTokenForUserUuidRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGetTokenForUserUuidRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>>
export type TestingGetTokenForUserUuidRetrieveQueryError = void


export function useTestingGetTokenForUserUuidRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError = void>(
 params: undefined |  TestingGetTokenForUserUuidRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForUserUuidRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError = void>(
 params?: TestingGetTokenForUserUuidRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForUserUuidRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError = void>(
 params?: TestingGetTokenForUserUuidRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGetTokenForUserUuidRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError = void>(
 params?: TestingGetTokenForUserUuidRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUserUuidRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGetTokenForUserUuidRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingGetTokenForUsernameRetrieveUrl = (params?: TestingGetTokenForUsernameRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/get_token_for_username/?${stringifiedParams}` : `/api/testing/get_token_for_username/`
}

/**
 * Get authentication (Bearer) token for specified existing username.
 */
export const testingGetTokenForUsernameRetrieve = async (params?: TestingGetTokenForUsernameRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingGetTokenForUsernameRetrieve200> => {

  return customFetch<TestingGetTokenForUsernameRetrieve200>(getTestingGetTokenForUsernameRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingGetTokenForUsernameRetrieveQueryKey = (params?: TestingGetTokenForUsernameRetrieveParams,) => {
    return [
    `/api/testing/get_token_for_username/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingGetTokenForUsernameRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError = void>(params?: TestingGetTokenForUsernameRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingGetTokenForUsernameRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>> = ({ signal }) => testingGetTokenForUsernameRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingGetTokenForUsernameRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>>
export type TestingGetTokenForUsernameRetrieveQueryError = void


export function useTestingGetTokenForUsernameRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError = void>(
 params: undefined |  TestingGetTokenForUsernameRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForUsernameRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError = void>(
 params?: TestingGetTokenForUsernameRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingGetTokenForUsernameRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError = void>(
 params?: TestingGetTokenForUsernameRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingGetTokenForUsernameRetrieve<TData = Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError = void>(
 params?: TestingGetTokenForUsernameRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingGetTokenForUsernameRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingGetTokenForUsernameRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingInvalidateAllCacheRetrieveUrl = () => {




  return `/api/testing/invalidate_all_cache/`
}

/**
 * Invalidate all cacheops cache
 */
export const testingInvalidateAllCacheRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestingInvalidateAllCacheRetrieve200> => {

  return customFetch<TestingInvalidateAllCacheRetrieve200>(getTestingInvalidateAllCacheRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingInvalidateAllCacheRetrieveQueryKey = () => {
    return [
    `/api/testing/invalidate_all_cache/`
    ] as const;
    }


export const getTestingInvalidateAllCacheRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingInvalidateAllCacheRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>> = ({ signal }) => testingInvalidateAllCacheRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingInvalidateAllCacheRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>>
export type TestingInvalidateAllCacheRetrieveQueryError = void


export function useTestingInvalidateAllCacheRetrieve<TData = Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingInvalidateAllCacheRetrieve<TData = Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingInvalidateAllCacheRetrieve<TData = Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingInvalidateAllCacheRetrieve<TData = Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingInvalidateAllCacheRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingInvalidateAllCacheRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingMoveGigToPastCreateUrl = (gigId: number,
    params?: TestingMoveGigToPastCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/move-gig-to-past/${gigId}/?${stringifiedParams}` : `/api/testing/move-gig-to-past/${gigId}/`
}

/**
 * Modify gig end_time to requested number of hours in the past from now (default: 24 hours).
 */
export const testingMoveGigToPastCreate = async (gigId: number,
    params?: TestingMoveGigToPastCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<MoveGigToPastResponse> => {

  return customFetch<MoveGigToPastResponse>(getTestingMoveGigToPastCreateUrl(gigId,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestingMoveGigToPastCreateMutationKey = () => ['testingMoveGigToPastCreate'] as const;

export const getTestingMoveGigToPastCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingMoveGigToPastCreate>>, TError,TestingMoveGigToPastCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingMoveGigToPastCreate>>, TError,TestingMoveGigToPastCreateMutationVariables, TContext> => {

const mutationKey = getTestingMoveGigToPastCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingMoveGigToPastCreate>>, TestingMoveGigToPastCreateMutationVariables> = (props) => {
          const {gigId,params} = props ?? {};

          return  testingMoveGigToPastCreate(gigId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingMoveGigToPastCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingMoveGigToPastCreate>>>

    export type TestingMoveGigToPastCreateMutationError = void
    export type TestingMoveGigToPastCreateMutationVariables = {gigId: number;params?: TestingMoveGigToPastCreateParams}

    export const useTestingMoveGigToPastCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingMoveGigToPastCreate>>, TError,TestingMoveGigToPastCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingMoveGigToPastCreate>>,
        TError,
        TestingMoveGigToPastCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingMoveGigToPastCreateMutationOptions(options), queryClient);
    }
    export const getTestingReleasePhoneNumberDestroyUrl = (params?: TestingReleasePhoneNumberDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/release_phone_number/?${stringifiedParams}` : `/api/testing/release_phone_number/`
}

/**
 * Release a phone_number used by Pros
 */
export const testingReleasePhoneNumberDestroy = async (params?: TestingReleasePhoneNumberDestroyParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingReleasePhoneNumberDestroy200> => {

  return customFetch<TestingReleasePhoneNumberDestroy200>(getTestingReleasePhoneNumberDestroyUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTestingReleasePhoneNumberDestroyMutationKey = () => ['testingReleasePhoneNumberDestroy'] as const;

export const getTestingReleasePhoneNumberDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingReleasePhoneNumberDestroy>>, TError,TestingReleasePhoneNumberDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingReleasePhoneNumberDestroy>>, TError,TestingReleasePhoneNumberDestroyMutationVariables, TContext> => {

const mutationKey = getTestingReleasePhoneNumberDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingReleasePhoneNumberDestroy>>, TestingReleasePhoneNumberDestroyMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  testingReleasePhoneNumberDestroy(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingReleasePhoneNumberDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof testingReleasePhoneNumberDestroy>>>

    export type TestingReleasePhoneNumberDestroyMutationError = void
    export type TestingReleasePhoneNumberDestroyMutationVariables = {params?: TestingReleasePhoneNumberDestroyParams}

    export const useTestingReleasePhoneNumberDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingReleasePhoneNumberDestroy>>, TError,TestingReleasePhoneNumberDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingReleasePhoneNumberDestroy>>,
        TError,
        TestingReleasePhoneNumberDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getTestingReleasePhoneNumberDestroyMutationOptions(options), queryClient);
    }
    export const getTestingRemoveUserLicenseDestroyUrl = () => {




  return `/api/testing/remove_user_license/`
}

/**
 * Removes a license from a user on a location. This endpoint is idempotent
 */
export const testingRemoveUserLicenseDestroy = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestingRemoveUserLicenseDestroy200 | TestingRemoveUserLicenseDestroy204> => {

  return customFetch<TestingRemoveUserLicenseDestroy200 | TestingRemoveUserLicenseDestroy204>(getTestingRemoveUserLicenseDestroyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTestingRemoveUserLicenseDestroyMutationKey = () => ['testingRemoveUserLicenseDestroy'] as const;

export const getTestingRemoveUserLicenseDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingRemoveUserLicenseDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingRemoveUserLicenseDestroy>>, TError,void, TContext> => {

const mutationKey = getTestingRemoveUserLicenseDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingRemoveUserLicenseDestroy>>, void> = () => {


          return  testingRemoveUserLicenseDestroy(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingRemoveUserLicenseDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof testingRemoveUserLicenseDestroy>>>

    export type TestingRemoveUserLicenseDestroyMutationError = void


    export const useTestingRemoveUserLicenseDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingRemoveUserLicenseDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingRemoveUserLicenseDestroy>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestingRemoveUserLicenseDestroyMutationOptions(options), queryClient);
    }
    export const getTestingRunRippleRulesRetrieveUrl = () => {




  return `/api/testing/run_ripple_rules/`
}

/**
 * Runs background task to execute ripple rules and to auto-select for pros.
 */
export const testingRunRippleRulesRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestingRunRippleRulesRetrieve200> => {

  return customFetch<TestingRunRippleRulesRetrieve200>(getTestingRunRippleRulesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingRunRippleRulesRetrieveQueryKey = () => {
    return [
    `/api/testing/run_ripple_rules/`
    ] as const;
    }


export const getTestingRunRippleRulesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingRunRippleRulesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>> = ({ signal }) => testingRunRippleRulesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingRunRippleRulesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>>
export type TestingRunRippleRulesRetrieveQueryError = void


export function useTestingRunRippleRulesRetrieve<TData = Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingRunRippleRulesRetrieve<TData = Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingRunRippleRulesRetrieve<TData = Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingRunRippleRulesRetrieve<TData = Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingRunRippleRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingRunRippleRulesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingSeedFixtureCreateUrl = () => {




  return `/api/testing/seed_fixture/`
}

/**
 * Stage a whole business fixture in one call: staffer, market, org, approved location,
 * manager profile, skills, any number of gigs with explicit windows, pros (each optionally
 * confirmed onto one of those gigs), and pro groups built from those pros.
 *
 * CORE-7858. A spec that stages this chain one endpoint at a time takes roughly seventeen
 * independent chances to hit a transient failure against a shared API, and the harness reports
 * that as a spec failure that says nothing about the product. One call is one chance.
 *
 * A pro's ``confirmed_on_gig_index`` is optional — an unconfirmed pro stages onboarding only,
 * which is what a pro group's members need (a group does not itself require any member to be
 * confirmed onto a gig).
 *
 * Kept separate from ``seed_scenario`` deliberately: that endpoint has live callers whose
 * behaviour must not move, and its scenario presets carry fields these specs do not use.
 */
export const testingSeedFixtureCreate = async (seedFixtureRequest?: SeedFixtureRequest, options?: Parameters<typeof customFetch>[1]): Promise<TestingSeedFixtureCreate201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TestingSeedFixtureCreate201>(getTestingSeedFixtureCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(seedFixtureRequest)
  }
);}





export const getTestingSeedFixtureCreateMutationKey = () => ['testingSeedFixtureCreate'] as const;

export const getTestingSeedFixtureCreateMutationOptions = <TError = TestingSeedFixtureCreate400 | void | TestingSeedFixtureCreate409 | TestingSeedFixtureCreate422 | TestingSeedFixtureCreate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingSeedFixtureCreate>>, TError,TestingSeedFixtureCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingSeedFixtureCreate>>, TError,TestingSeedFixtureCreateMutationVariables, TContext> => {

const mutationKey = getTestingSeedFixtureCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingSeedFixtureCreate>>, TestingSeedFixtureCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testingSeedFixtureCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingSeedFixtureCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingSeedFixtureCreate>>>
    export type TestingSeedFixtureCreateMutationBody = SeedFixtureRequest | undefined
    export type TestingSeedFixtureCreateMutationError = TestingSeedFixtureCreate400 | void | TestingSeedFixtureCreate409 | TestingSeedFixtureCreate422 | TestingSeedFixtureCreate429
    export type TestingSeedFixtureCreateMutationVariables = {data?: SeedFixtureRequest}

    export const useTestingSeedFixtureCreate = <TError = TestingSeedFixtureCreate400 | void | TestingSeedFixtureCreate409 | TestingSeedFixtureCreate422 | TestingSeedFixtureCreate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingSeedFixtureCreate>>, TError,TestingSeedFixtureCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingSeedFixtureCreate>>,
        TError,
        TestingSeedFixtureCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingSeedFixtureCreateMutationOptions(options), queryClient);
    }
    export const getTestingSeedGigBreakRetrieveUrl = (applicationId: number,) => {




  return `/api/testing/seed_gig_break/${applicationId}/`
}

/**
 * Seed the gig's REQUIRED unpaid break with application_confirmed's own call, for environments where
 * that task does not run. A break the pro already edited is left alone (``seeded: false``).
 */
export const testingSeedGigBreakRetrieve = async (applicationId: number, options?: Parameters<typeof customFetch>[1]): Promise<TestingSeedGigBreakRetrieve200> => {

  return customFetch<TestingSeedGigBreakRetrieve200>(getTestingSeedGigBreakRetrieveUrl(applicationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingSeedGigBreakRetrieveQueryKey = (applicationId: number,) => {
    return [
    `/api/testing/seed_gig_break/${applicationId}/`
    ] as const;
    }


export const getTestingSeedGigBreakRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError = void>(applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingSeedGigBreakRetrieveQueryKey(applicationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>> = ({ signal }) => testingSeedGigBreakRetrieve(applicationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: applicationId !== null && applicationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingSeedGigBreakRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>>
export type TestingSeedGigBreakRetrieveQueryError = void


export function useTestingSeedGigBreakRetrieve<TData = Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError = void>(
 applicationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingSeedGigBreakRetrieve<TData = Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingSeedGigBreakRetrieve<TData = Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingSeedGigBreakRetrieve<TData = Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedGigBreakRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingSeedGigBreakRetrieveQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingSeedRosterProRetrieveUrl = (gigId: number,) => {




  return `/api/testing/seed_roster_pro/${gigId}/`
}

/**
 * Create one real-named pro on a gig: applicant or confirmed, with optional
 * clock punches, break, and rating. The single no-junk roster/applicant primitive.
 */
export const testingSeedRosterProRetrieve = async (gigId: number, options?: Parameters<typeof customFetch>[1]): Promise<TestingSeedRosterProRetrieve200> => {

  return customFetch<TestingSeedRosterProRetrieve200>(getTestingSeedRosterProRetrieveUrl(gigId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingSeedRosterProRetrieveQueryKey = (gigId: number,) => {
    return [
    `/api/testing/seed_roster_pro/${gigId}/`
    ] as const;
    }


export const getTestingSeedRosterProRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError = void | TestingSeedRosterProRetrieve404>(gigId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingSeedRosterProRetrieveQueryKey(gigId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>> = ({ signal }) => testingSeedRosterProRetrieve(gigId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: gigId !== null && gigId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingSeedRosterProRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>>
export type TestingSeedRosterProRetrieveQueryError = void | TestingSeedRosterProRetrieve404


export function useTestingSeedRosterProRetrieve<TData = Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError = void | TestingSeedRosterProRetrieve404>(
 gigId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingSeedRosterProRetrieve<TData = Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError = void | TestingSeedRosterProRetrieve404>(
 gigId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingSeedRosterProRetrieve<TData = Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError = void | TestingSeedRosterProRetrieve404>(
 gigId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingSeedRosterProRetrieve<TData = Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError = void | TestingSeedRosterProRetrieve404>(
 gigId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSeedRosterProRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingSeedRosterProRetrieveQueryOptions(gigId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingSeedScenarioCreateUrl = () => {




  return `/api/testing/seed_scenario/`
}

/**
 * Seed a complete test scenario.
 */
export const testingSeedScenarioCreate = async (seedScenarioRequest?: SeedScenarioRequest, options?: Parameters<typeof customFetch>[1]): Promise<TestingSeedScenarioCreate201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TestingSeedScenarioCreate201>(getTestingSeedScenarioCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(seedScenarioRequest)
  }
);}





export const getTestingSeedScenarioCreateMutationKey = () => ['testingSeedScenarioCreate'] as const;

export const getTestingSeedScenarioCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingSeedScenarioCreate>>, TError,TestingSeedScenarioCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingSeedScenarioCreate>>, TError,TestingSeedScenarioCreateMutationVariables, TContext> => {

const mutationKey = getTestingSeedScenarioCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingSeedScenarioCreate>>, TestingSeedScenarioCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testingSeedScenarioCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingSeedScenarioCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingSeedScenarioCreate>>>
    export type TestingSeedScenarioCreateMutationBody = SeedScenarioRequest | undefined
    export type TestingSeedScenarioCreateMutationError = void
    export type TestingSeedScenarioCreateMutationVariables = {data?: SeedScenarioRequest}

    export const useTestingSeedScenarioCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingSeedScenarioCreate>>, TError,TestingSeedScenarioCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingSeedScenarioCreate>>,
        TError,
        TestingSeedScenarioCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingSeedScenarioCreateMutationOptions(options), queryClient);
    }
    export const getTestingSetProCoordinatesRetrieveUrl = (params: TestingSetProCoordinatesRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/set_pro_coordinates/?${stringifiedParams}` : `/api/testing/set_pro_coordinates/`
}

/**
 * Set last known coordinates for a pro user. Used for testing Match V3 distance-based matching.
 */
export const testingSetProCoordinatesRetrieve = async (params: TestingSetProCoordinatesRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingSetProCoordinatesRetrieve200> => {

  return customFetch<TestingSetProCoordinatesRetrieve200>(getTestingSetProCoordinatesRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingSetProCoordinatesRetrieveQueryKey = (params?: TestingSetProCoordinatesRetrieveParams,) => {
    return [
    `/api/testing/set_pro_coordinates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingSetProCoordinatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError = void>(params: TestingSetProCoordinatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingSetProCoordinatesRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>> = ({ signal }) => testingSetProCoordinatesRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingSetProCoordinatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>>
export type TestingSetProCoordinatesRetrieveQueryError = void


export function useTestingSetProCoordinatesRetrieve<TData = Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError = void>(
 params: TestingSetProCoordinatesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingSetProCoordinatesRetrieve<TData = Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError = void>(
 params: TestingSetProCoordinatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingSetProCoordinatesRetrieve<TData = Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError = void>(
 params: TestingSetProCoordinatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingSetProCoordinatesRetrieve<TData = Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError = void>(
 params: TestingSetProCoordinatesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingSetProCoordinatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingSetProCoordinatesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingStageBackgroundCheckCreateUrl = (params: TestingStageBackgroundCheckCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/stage_background_check/?${stringifiedParams}` : `/api/testing/stage_background_check/`
}

/**
 * Put a pro's background check into a chosen state: an invitation that is only SENT, a report still
 * PENDING / IN_PROGRESS, a CLEAR check that has expired or sits inside its one-week renewal window, a
 * DID_NOT_PASS, a CONSIDER result, and so on. Updates the pro's latest check in place (201 when it had to
 * be created), so repeated calls walk one seed through states. Every body field is optional and a field
 * left out is reset to its default, so each call fully describes the resulting state; the defaults match
 * ``create_and_approve_background_check``. ``expiration_date`` omitted is a year from now, ``null`` is no
 * expiry (``active()`` treats both a future date and null as current).
 */
export const testingStageBackgroundCheckCreate = async (params: TestingStageBackgroundCheckCreateParams,
    stageBackgroundCheckRequest?: StageBackgroundCheckRequest, options?: Parameters<typeof customFetch>[1]): Promise<BackgroundCheck> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BackgroundCheck>(getTestingStageBackgroundCheckCreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stageBackgroundCheckRequest)
  }
);}





export const getTestingStageBackgroundCheckCreateMutationKey = () => ['testingStageBackgroundCheckCreate'] as const;

export const getTestingStageBackgroundCheckCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingStageBackgroundCheckCreate>>, TError,TestingStageBackgroundCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingStageBackgroundCheckCreate>>, TError,TestingStageBackgroundCheckCreateMutationVariables, TContext> => {

const mutationKey = getTestingStageBackgroundCheckCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingStageBackgroundCheckCreate>>, TestingStageBackgroundCheckCreateMutationVariables> = (props) => {
          const {params,data} = props ?? {};

          return  testingStageBackgroundCheckCreate(params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingStageBackgroundCheckCreateMutationResult = NonNullable<Awaited<ReturnType<typeof testingStageBackgroundCheckCreate>>>
    export type TestingStageBackgroundCheckCreateMutationBody = StageBackgroundCheckRequest | undefined
    export type TestingStageBackgroundCheckCreateMutationError = void
    export type TestingStageBackgroundCheckCreateMutationVariables = {params: TestingStageBackgroundCheckCreateParams;data?: StageBackgroundCheckRequest}

    export const useTestingStageBackgroundCheckCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingStageBackgroundCheckCreate>>, TError,TestingStageBackgroundCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingStageBackgroundCheckCreate>>,
        TError,
        TestingStageBackgroundCheckCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingStageBackgroundCheckCreateMutationOptions(options), queryClient);
    }
    export const getTestingUpdateMarketPartialUpdateUrl = (marketId: number,) => {




  return `/api/testing/update_market/${marketId}/`
}

/**
 * Update market details.
 */
export const testingUpdateMarketPartialUpdate = async (marketId: number,
    patchedMarketRequest?: PatchedMarketRequest, options?: Parameters<typeof customFetch>[1]): Promise<Market> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Market>(getTestingUpdateMarketPartialUpdateUrl(marketId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedMarketRequest)
  }
);}





export const getTestingUpdateMarketPartialUpdateMutationKey = () => ['testingUpdateMarketPartialUpdate'] as const;

export const getTestingUpdateMarketPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingUpdateMarketPartialUpdate>>, TError,TestingUpdateMarketPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testingUpdateMarketPartialUpdate>>, TError,TestingUpdateMarketPartialUpdateMutationVariables, TContext> => {

const mutationKey = getTestingUpdateMarketPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingUpdateMarketPartialUpdate>>, TestingUpdateMarketPartialUpdateMutationVariables> = (props) => {
          const {marketId,data} = props ?? {};

          return  testingUpdateMarketPartialUpdate(marketId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestingUpdateMarketPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof testingUpdateMarketPartialUpdate>>>
    export type TestingUpdateMarketPartialUpdateMutationBody = PatchedMarketRequest | undefined
    export type TestingUpdateMarketPartialUpdateMutationError = void
    export type TestingUpdateMarketPartialUpdateMutationVariables = {marketId: number;data?: PatchedMarketRequest}

    export const useTestingUpdateMarketPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingUpdateMarketPartialUpdate>>, TError,TestingUpdateMarketPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingUpdateMarketPartialUpdate>>,
        TError,
        TestingUpdateMarketPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTestingUpdateMarketPartialUpdateMutationOptions(options), queryClient);
    }
    export const getTestingUpdateZealPiiRetrieveUrl = (params: TestingUpdateZealPiiRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/update_zeal_pii/?${stringifiedParams}` : `/api/testing/update_zeal_pii/`
}

/**
 * Send test PII (dob, ssn, phone, address) to Zeal for a W2 pro.
 *
 * Use after add_gigster_profile_w2_details. Does not mark the employee as onboarded.
 */
export const testingUpdateZealPiiRetrieve = async (params: TestingUpdateZealPiiRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingUpdateZealPiiRetrieve200> => {

  return customFetch<TestingUpdateZealPiiRetrieve200>(getTestingUpdateZealPiiRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingUpdateZealPiiRetrieveQueryKey = (params?: TestingUpdateZealPiiRetrieveParams,) => {
    return [
    `/api/testing/update_zeal_pii/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingUpdateZealPiiRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError = void>(params: TestingUpdateZealPiiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingUpdateZealPiiRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>> = ({ signal }) => testingUpdateZealPiiRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingUpdateZealPiiRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>>
export type TestingUpdateZealPiiRetrieveQueryError = void


export function useTestingUpdateZealPiiRetrieve<TData = Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError = void>(
 params: TestingUpdateZealPiiRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingUpdateZealPiiRetrieve<TData = Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError = void>(
 params: TestingUpdateZealPiiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingUpdateZealPiiRetrieve<TData = Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError = void>(
 params: TestingUpdateZealPiiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingUpdateZealPiiRetrieve<TData = Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError = void>(
 params: TestingUpdateZealPiiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingUpdateZealPiiRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingUpdateZealPiiRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTestingValidateTokenRetrieveUrl = (params?: TestingValidateTokenRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/testing/validate_token/?${stringifiedParams}` : `/api/testing/validate_token/`
}

/**
 * Print out JWT token details.
 */
export const testingValidateTokenRetrieve = async (params?: TestingValidateTokenRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TestingValidateTokenRetrieve200> => {

  return customFetch<TestingValidateTokenRetrieve200>(getTestingValidateTokenRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestingValidateTokenRetrieveQueryKey = (params?: TestingValidateTokenRetrieveParams,) => {
    return [
    `/api/testing/validate_token/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTestingValidateTokenRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError = void>(params?: TestingValidateTokenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingValidateTokenRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>> = ({ signal }) => testingValidateTokenRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingValidateTokenRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>>
export type TestingValidateTokenRetrieveQueryError = void


export function useTestingValidateTokenRetrieve<TData = Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError = void>(
 params: undefined |  TestingValidateTokenRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingValidateTokenRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingValidateTokenRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingValidateTokenRetrieve<TData = Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError = void>(
 params?: TestingValidateTokenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingValidateTokenRetrieve>>,
          TError,
          Awaited<ReturnType<typeof testingValidateTokenRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingValidateTokenRetrieve<TData = Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError = void>(
 params?: TestingValidateTokenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingValidateTokenRetrieve<TData = Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError = void>(
 params?: TestingValidateTokenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingValidateTokenRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingValidateTokenRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






